import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';
import { RoundButton } from './common';
import { upgradeUrl } from './util';

const PremiumBadgeIcon = styled.div`
  position: relative;
  top: -2px;
`;

// The container, on load, has its leftmost edge aligned with the leftmost edge of the icon.
// In order for it to be centered about the center the icon, it must be translated:
// * left (-50%), so its center is aligned with the leftmost edge of the icon;
// * right (+9px), which is half the width of the icon (18px)
const CENTER_CONTAINER_TO_ICON = `-50% + 9px`;

const Container = styled.div`
  background: #0954d3;
  width: 343px;
  height: 111px;
  padding: 19px 16px 22px 0px;
  border-radius: 6px;

  position: absolute;
  top: 36px;
  display: flex;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.4);
  z-index: 1;

  // translate -50% plus half of icon width (18px)
  transform: translate(calc(${CENTER_CONTAINER_TO_ICON}));

  // give user a larger hover area
  &:before {
    content: '';
    position: absolute;
    top: -36px;
    left: 50%;
    transform: translate(-50%);
    width: 36px;
    height: 50%;
  }
`;

const Triangle = styled.div`
  position: absolute;

  width: 0px;
  height: 0px;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #0954d3;
  top: -14px;
  left: 50%;
  transform: translate(-50%);
`;

const PopoverIconLaurel = styled.img`
  height: 42px;
  margin: 0px 12px 0px 16px;
`;

const PopoverInfo = styled.div``;

const PopoverText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  /* or 136% */
  letter-spacing: 0.02em;

  color: #ffffff;
`;

const PopoverCTA = styled(RoundButton)`
  background: #ffffff;
  border-radius: 78.7611px;
  height: 18px;
  width: 89px;
  color: #0954d3;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 13px;
  margin-bottom: 0px;
`;

const PremiumBadge = () => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <PremiumBadgeIcon
      onMouseOver={() => setShowPopover(true)}
      onMouseLeave={() => setShowPopover(false)}
    >
      <img src={$image_url('premium/Badge-Laurel.svg')} />
      {showPopover && <PremiumBadgePopover />}
    </PremiumBadgeIcon>
  );
};

const PremiumBadgePopover = () => {
  const parentContainer = useRef(null);
  const triangle = useRef(null);
  useLayoutEffect(() => {
    // type never?
    const containerDOM = parentContainer?.current;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const containerDOMRect = containerDOM?.getBoundingClientRect();
    const containerRightEdge = containerDOMRect.right;
    const viewportWidth = window.innerWidth;
    const MINIMUM_RIGHT_PADDING = 10;
    if (containerRightEdge > viewportWidth - MINIMUM_RIGHT_PADDING) {
      //  adjustedEdge
      //       |
      //      viewport    rightEdge
      //       | |           |
      //       x x           x
      //
      // distance btwn rightEdge and adjustedEdge is minPadding + (rightEdge - viewport)
      const distance =
        MINIMUM_RIGHT_PADDING + containerRightEdge - viewportWidth;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      containerDOM.style.transform = `translateX(calc(${CENTER_CONTAINER_TO_ICON} - ${distance}px))`;

      // adjust the triangle
      const triangleDOM = triangle?.current;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      triangleDOM.style.transform = `translateX(calc(-50% + ${distance}px))`;
    }
  });

  return (
    <Container
      ref={parentContainer}
      style={{ animation: '180ms fade-in ease-in' }}
    >
      <Triangle ref={triangle} />
      <PopoverIconLaurel src={$image_url('premium/Badge-Laurel.svg')} />
      <PopoverInfo>
        <PopoverText>
          270,000 Academics from 16,000 universities are Premium members.
        </PopoverText>
        <PopoverCTA as="a" href={upgradeUrl()}>
          Learn more
        </PopoverCTA>
      </PopoverInfo>
    </Container>
  );
};

export default PremiumBadge;
